import { render, staticRenderFns } from "./user-add-dialog.vue?vue&type=template&id=579b2ebc&scoped=true&"
import script from "./user-add-dialog.vue?vue&type=script&lang=js&"
export * from "./user-add-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579b2ebc",
  null
  
)

export default component.exports